@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.contacts

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.ContactDto
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto


object GetPassengerContactsEndpoint :
    EndPoint<GetPassengerContactsEndpoint.Request, GetPassengerContactsEndpoint.Response>() {
    class Request

    class Response(
        val contacts: Array<ContactDto>,
    )
}